/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Price } from 'src/sdk-search';
import { Flights } from './flights';

/**
 * バウンド情報リスト
 */
export interface Bounds {
  /**
   * TravelSolutionId
   */
  travelSolutionId?: string;

  /**
   * FareFamilyCode
   */
  fareFamilyCode?: string;

  /**
   * 金額金額情報
   */
  totalPrice?: Price;

  /**
   * 残席状況。当該バウンドのセグメントのうち、最も残席数が少ないセグメントの情報 <br>
   *   enough：十分空席あり <br>
   *   available：空席あり <br>
   *   few：残席実数 <br>
   *   soldOut：売り切れ <br>
   * ※DxAPIの残席数をもとに、設定ファイルの閾値に沿って上記のいずれかに該当するかを、以下の順に判定する。 <br>
   * 　1)残席数が搭乗者数(幼児は含まない)を下回っている場合は、売り切れを返却 <br>
   * 　2)実数表示上限値に設定があり、設定値以下であれば、残席実数を返却 <br>
   * 　3)空席あり表示上限値に設定があり、設定値以下であれば、空席ありを返却 <br>
   * 　4)上記以外であれば、十分空席ありを返却
   */
  quotaType?: Bounds.QuotaTypeEnum;

  /**
   * 残席数。当該バウンドのセグメントのうち、最も残席数が少ないセグメントの情報 <br>
   * ※quotaTypeが「few」の場合に返却される
   */
  quota?: number;

  /**
   * 無料預け入れ手荷物個数 <br>
   * 当該バウンド内に含まれるセグメントに対する最小の値を回答する <br>
   * ※ただし、DxAPIより全セグメントに対する手荷物情報に対して、重量のみで回答された場合には返却せず、個数と重量が混在した回答の場合には、個数のみを考慮して回答する <br>
   * ※DxAPIより個数情報が返却された場合のみ返却する
   */
  minFreeCheckedBaggageQuantity?: number;

  /**
   * 無料機内持ち込み手荷物個数 <br>
   * 当該バウンド内に含まれるセグメントに対する最小の値を回答する <br>
   * ※ただし、DxAPIより全セグメントに対する手荷物情報に対して、重量のみで回答された場合には返却せず、個数と重量が混在した回答の場合には、個数のみを考慮して回答する <br>
   * ※DxAPIより個数情報が返却された場合のみ返却する
   */
  minFreeCarryOnBaggageQuantity?: number;

  /**
   * 事前追加手荷物の申込可否 <br>
   * 下記条件を満たす場合に、true <br>
   * X　NHグループ運航国際線である。 <br>
   * 1　当該AirOfferに、米国発着またはカナダ発着のセグメントを含まない。 <br>
   * 2　当該バウンドの日本国内区間以外のセグメントが全てNHグループ運航である。 <br>
   * 3　当該の日本国内区間の運航キャリアに、設定ファイルにて管理する事前追加手荷物利用不可キャリアを含まない。
   */
  isFirstBaggageAvailable?: boolean;

  /**
   * 変更条件タイプ <br>
   * 当該バウンドのPriority Codeをキーに取得した、ASWDB(マスタ)の変更可否区分を返却する <br>
   * unavailable：予約変更不可 <br>
   * withPenalty：予約変更可能（手数料あり） <br>
   * free：予約変更可能（手数料なし）
   */
  changeConditionsType?: Bounds.ChangeConditionsTypeEnum;

  /**
   * 払戻条件タイプ
   * 当該バウンドのPriority Codeをキーに取得した、ASWDB(マスタ)の払戻可否区分を返却する
   * unavailable：払戻不可
   * withPenalty：払戻可能（手数料あり）
   * free：払戻可能（手数料なし）
   */
  refundConditionsType?: Bounds.RefundConditionsTypeEnum;

  /**
   * セグメント情報リスト
   */
  flights?: Array<Flights>;
}

export namespace Bounds {
  /** 残席状況 */
  export type QuotaTypeEnum = 'enough' | 'available' | 'few' | 'soldOut';
  export const QuotaTypeEnum = {
    /** 十分空席あり */
    Enough: 'enough' as QuotaTypeEnum,
    /** 空席あり */
    Available: 'available' as QuotaTypeEnum,
    /** 残席実数 */
    Few: 'few' as QuotaTypeEnum,
    /** 売り切れ */
    SoldOut: 'soldOut' as QuotaTypeEnum,
  };

  /** 変更条件タイプ */
  export type ChangeConditionsTypeEnum = 'unavailable' | 'withPenalty' | 'free';
  export const ChangeConditionsTypeEnum = {
    /** 予約変更不可 */
    unavailable: 'unavailable' as ChangeConditionsTypeEnum,
    /** 予約変更可能（手数料あり） */
    withPenalty: 'withPenalty' as ChangeConditionsTypeEnum,
    /** 予約変更可能（手数料なし） */
    free: 'free' as ChangeConditionsTypeEnum,
  };

  /** 払戻条件タイプ */
  export type RefundConditionsTypeEnum = 'unavailable' | 'withPenalty' | 'free';
  export const RefundConditionsTypeEnum = {
    /** 払戻不可 */
    unavailable: 'unavailable' as RefundConditionsTypeEnum,
    /** 払戻可能（手数料あり） */
    withPenalty: 'withPenalty' as RefundConditionsTypeEnum,
    /** 払戻可能（手数料なし） */
    free: 'free' as RefundConditionsTypeEnum,
  };
}
